import * as types from "./actionTypes"

const initialState = {
    demurrageSummaries: [],
    demurrageDetails: [],
    selectedSummary: [],
}
export default function chargeManagementReducer(state = initialState, action) {
    switch (action.type) {
        case types.CHARGE_SUMMARIES_FETCH_SUCCESS:
            return {
                ...state,
                demurrageSummaries: action.payload["DemurrageRevenueSummaries"],
            }
        case types.CHARGE_SUMMARIES_DETAILS_FETCH_SUCCESS:
            return {
                ...state,
                demurrageDetails: action.payload["DemurrageDetails"],
            }
        case types.CLEAR_SELECTED_SUMMARY:
            return {
                ...state,
                selectedSummary: [],
            }
        case types.UPDATE_SELECTED_SUMMARY:
            return {
                ...state,
                selectedSummary: action.payload,
            }
        default:
            return state
    }
}
